import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/responsible-investments-desktop.webp';
import imageMobileWebp from './images/responsible-investments-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-environment-connecting-employees-environment'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText={<>Connecting corporate employees with <WidowBlock>the environment</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          Access to nature is a key part of our campus experience. Garden areas like the green roof at our Milwaukee campus, in addition to making our cities more climate resilient and enhancing local biodiversity, are regularly cited by employees as having a positive impact on their well-being at work.
        </Typography>
      </>
    )}
    // image props
    imageAltText='An overhead view of the top of the Northwestern Mutual building with grass roofs and trees outside'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
